import { Box, Button, Icon, IconsName, Text } from '@fairfashion/design-system'
import { useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import * as Styles from '../reports.styles'

interface ReportsCardProps {
  icon?: IconsName
  count: number
  title?: string
  subtitle?: string
  counterTitle?: string
  link?: string
}
export const ReportsCard = ({
  count,
  icon,
  title,
  subtitle,
  counterTitle,
  link,
}: ReportsCardProps) => {
  const theme = useTheme()
  const navigate = useNavigate()
  return (
    <Styles.Card direction="column" padding={3} flex={1} minWidth="320px">
      <Box height="275px" direction="column" justifyContent="space-between">
        <Box direction="column" gap={2}>
          <Text fontWeight={500}>{title}</Text>
          <Text color="grey_3">{subtitle}</Text>
        </Box>
        <Styles.Card width="100%" alignItems="center" padding={2}>
          <Box
            border={{ width: 1, color: 'grey_4' }}
            padding={1}
            borderRadius={theme.border_radius.input}
          >
            <Icon name={icon ?? 'file4'} size={18} color="secondary"></Icon>
          </Box>
          <Box direction="column">
            <Text color="grey_3" size="small">
              {counterTitle}
            </Text>
            <Text fontWeight={500} size="large">
              {count}
            </Text>
          </Box>
        </Styles.Card>
      </Box>
      <Button onClick={() => navigate(`/reports/${link}`)}>Ver mais</Button>
    </Styles.Card>
  )
}
